import Axios from "axios";
import * as types from "../mutation-types";

import {
  SET_USER_LOGGED_IN,
  SET_USER_TOKEN,
  SET_AUTH_USER,
  UNSET_AUTH_USER,
  UNSET_USER_LOGGED_IN,
  UNSET_USER_TOKEN,
  SET_USER_PERMISSION,
  UNSET_USER_PERMISSION,
  SET_USER_MESSAGE,
  UNSET_USER_MESSAGE
} from "../mutation-types";

import { userLoginRefreshUrl, userLoginUrl,userLogoutUrl } from "../api";
// initial state
const state = {
  UserLoggedIn: false,
  userToken: "",
  authUser: {},
  getNavbarItems:[],
  message: ""
};

const getters = {
  getAuthUser(state) {
    let user = JSON.parse(localStorage.getItem("user"));
    state.authUser = user;
    return state.authUser ? state.authUser : user;
  },
  getuserToken(state) {
    return state.userToken;
  },
  getNavbarItems(state) {
    let menu = JSON.parse(localStorage.getItem("menu"));
    state.getNavbarItems = menu;
    return state.getNavbarItems ? state.getNavbarItems : menu;

  },
  getMessage(state){
    return state.message;
  }

};
const mutations = {
  [SET_USER_LOGGED_IN](state) {
    state.UserLoggedIn = true;
  },
  [UNSET_USER_LOGGED_IN](state) {
    state.UserLoggedIn = false;
  },
  [SET_AUTH_USER](state, user) {
    state.authUser = user;
  },
  [UNSET_AUTH_USER](state) {
    state.authUser = {};
  },
  [SET_USER_TOKEN](state, token) {
    state.userToken = token;
  },
  [UNSET_USER_TOKEN](state) {
    state.userToken = "";
  },
  [SET_USER_PERMISSION](state, menu) {
    state.getNavbarItems = menu;
  },
  [UNSET_USER_PERMISSION](state) {
    state.getNavbarItems = [];
  },
  [SET_USER_MESSAGE](state, message) {
    state.message = message;
  },
  [UNSET_USER_MESSAGE](state) {
    state.message = "";
  },
  
};

const actions = {
  // sendUserEmail({ commit, state }, data) {
  //   return new Promise(function (resolve, reject) {
  //     var params = new URLSearchParams();
  //     params.append("email", data.email);
  //     params.append("base_url", frontendBaseUrl);
  //     Axios.post(sendUserEmail, params)
  //       .then((response) => {
  //         resolve(response)
  //       })
  //       .catch((error) => {
  //         reject(error)
  //       })
  //   })
  // },
  
  // sendOTPCreateAccount({ commit, state }, data) {
  //   return new Promise(function (resolve, reject) {
  //     var params = new URLSearchParams();
  //     params.append("email", data.email);
  //     Axios.post(sendOTPCreateAccount, params)
  //       .then((response) => {
  //         resolve(response)
  //       })
  //       .catch((error) => {
  //         reject(error)
  //       })
  //   })
  // },
  
  // verifyOTPCreateAccount({ commit, state }, data) {
  //   return new Promise(function (resolve, reject) {
  //     var params = new URLSearchParams();
  //     params.append("email", data.email);
  //     params.append("otp", data.otp);
  //     Axios.post(verifyOTPCreateAccount, params)
  //       .then((response) => {
  //         resolve(response)
  //       })
  //       .catch((error) => {
  //         reject(error)
  //       })
  //   })
  // },

  // checkUserResetPasswordTime({ commit, state }, data) {
  //   return new Promise(function (resolve, reject) {
  //     Axios.get(checkUserResetPasswordTime + '/' + data.reset_code, data)
  //       .then(function (response) {
  //         resolve(response);
  //       }).catch(error => {
  //         reject(error);
  //       });
  //   });
  // },

  // resetUserPassword({ commit, state }, data) {
  //   return new Promise(function (resolve, reject) {
  //     Axios.post(resetUserPassword + '/' + data.reset_code, data)
  //       .then(function (response) {
  //           resolve(response);
  //       }).catch(error => {
  //         reject(error);
  //         return error;
  //       });
  //   });
  // },

  // setUserPassword({ commit, state }, data) {
  //   return new Promise(function (resolve, reject) {
  //     // data.push({"url":frontendBaseUrl});
  //     Axios.post(setUserPassword + '/' + data.reset_code, data)
  //       .then(function (response) {
  //           resolve(response);
  //       }).catch(error => {
  //         reject(error);
  //         return error;
  //       });
  //   });
  // },

  loginRequest({ commit }, user) {
    var params = new URLSearchParams();
    localStorage.clear();
    params.append("username", user.username);
    params.append("password", user.password);
    return new Promise((resolve, reject) => {
      Axios.post(userLoginUrl, params)
        .then(function (response) {
          var token = response.data.authorization.token;
          var expires = response.data.authorization.expires_in;
          var menu = response.data.authorization.menu;
          var user = response.data.user;
          var branch = response.data.branch;
          var company_info = response.data.company_info;
          localStorage.setItem("guard", true);
          localStorage.setItem("token", token);
          localStorage.setItem("user", JSON.stringify(user));
          localStorage.setItem("user-expires", expires);
          localStorage.setItem("menu", JSON.stringify(menu));
          localStorage.setItem("branch", JSON.stringify(branch));
          localStorage.setItem("company", JSON.stringify(branch.company));
          localStorage.setItem("company_info", JSON.stringify(company_info));
          commit("SET_USER_LOGGED_IN");
          commit("SET_AUTH_USER", user);
          commit("SET_CURRENT_BRANCH", branch);
          commit("SET_CURRENT_COMPANY", branch.company);
          commit("SET_USER_PERMISSION", menu);
          commit("SET_USER_TOKEN", token);
          resolve(response);
        })
        .catch(function (error) {
          localStorage.removeItem("token");
          localStorage.removeItem("user-expires");
          commit("UNSET_USER_LOGGED_IN");
          commit("UNSET_AUTH_USER");
          commit("UNSET_CURRENT_BRANCH");
          commit("UNSET_CURRENT_COMPANY");
          commit("UNSET_USER_PERMISSION");
          commit("UNSET_USER_TOKEN");
          reject(error);
        })
        .then((always) => {
        });
    });
  },

  loginRefreshRequest({ commit }) {
    // localStorage.clear();
    
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", {color: "primary"});
      Axios.post(userLoginRefreshUrl)
        .then(function (response) {
          var token = response.data.authorization.token;
          var expires = response.data.authorization.expires_in;
          var menu = response.data.authorization.menu;
          var user = response.data.user;
          var branch = response.data.branch;
          var company_info = response.data.company_info;
          localStorage.setItem("guard", true);
          localStorage.setItem("token", token);
          localStorage.setItem("user", JSON.stringify(user));
          localStorage.setItem("user-expires", expires);
          localStorage.setItem("menu", JSON.stringify(menu));
          localStorage.setItem("branch", JSON.stringify(branch));
          localStorage.setItem("company", JSON.stringify(branch.company));
          localStorage.setItem("company_info", JSON.stringify(company_info));
          commit("SET_USER_LOGGED_IN");
          commit("SET_AUTH_USER", user);
          commit("SET_CURRENT_BRANCH", branch);
          commit("SET_CURRENT_COMPANY", branch.company);
          commit("SET_USER_PERMISSION", menu);
          commit("SET_USER_TOKEN", token);
          window.location.href = "/home/dashboard"
          resolve(response);
          
        })
        .catch(function (error) {
          localStorage.removeItem("token");
          localStorage.removeItem("user-expires");
          commit("UNSET_USER_LOGGED_IN");
          commit("UNSET_AUTH_USER");
          commit("UNSET_CURRENT_BRANCH");
          commit("UNSET_CURRENT_COMPANY");
          commit("UNSET_USER_PERMISSION");
          commit("UNSET_USER_TOKEN");
          reject(error);
        })
        .finally((always) => {
          commit("UNSET_LOADING")
        });
    });
  },

  logoutUser({ commit, state }) {
    Object.keys(types).forEach(key => {
      if (key.startsWith("UNSET_")) {
        commit(types[key]);
      }
    });
    commit("SET_LOADING", {color: "red-accent-4"});
    let Authorization = `Bearer ${state.userToken}`;
    return new Promise(function (resolve, reject)  {
      Axios.post(userLogoutUrl, {},
        {
          headers: {
            Authorization: Authorization,
            token_name: "user_token",
          },
        }
      )
      .then(function (response) {
          commit("UNSET_LOADING");
          localStorage.removeItem("user_token");
          localStorage.removeItem("user-expires");
          localStorage.removeItem("user");
          localStorage.removeItem("guard");
          localStorage.removeItem("menu");
          localStorage.removeItem("branch");
          localStorage.removeItem("company");
          localStorage.clear();
          commit("UNSET_USER_LOGGED_IN");
          commit("UNSET_AUTH_USER");
          commit("UNSET_CURRENT_BRANCH");
          commit("UNSET_CURRENT_COMPANY");
          commit("UNSET_USER_PERMISSION");
          commit("UNSET_USER_TOKEN");

          commit("UNSET_HRM_EMPLOYEE_PERMISSION_WISE_LIST");
          resolve(response);
      })
      .catch(function (error) {
        commit("UNSET_LOADING");
        reject(error);
      })
    });
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
